import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import {
  BookingCarrierDashboardResponse,
  BookingShipperDashboardResponse,
  BookingSuperAdminDashboardResponse,
} from '../../models/dashboard';
import { UserTypeEnum } from '../../enums/auth';
import { UMGUser } from '../../models/user';
import { UserFilterEnum } from '../../enums/user';

export const bookingEvents = eventGroup({
  source: 'Booking',
  events: {
    clear: type<void>(),
    setLoading: type<boolean>(),

    loadSuperAdminDashboardData: type<void>(),
    loadedSuperAdminDashboardData: type<BookingSuperAdminDashboardResponse>(),
    loadCarrierDashboardData: type<void>(),
    loadedCarrierDashboardData: type<BookingCarrierDashboardResponse>(),
    loadShipperDashboardData: type<void>(),
    loadedShipperDashboardData: type<BookingShipperDashboardResponse>(),
    loadShippersList: type<{
      userType: UserTypeEnum;
      filter: UserFilterEnum;
    }>(),
    loadedShippersList: type<UMGUser[]>(),
    loadCarriersList: type<{
      userType: UserTypeEnum;
      filter: UserFilterEnum;
    }>(),
    loadedCarriersList: type<UMGUser[]>(),
    changeShipperStatus: type<{
      updateSubject: string;
      updateStatus: boolean;
    }>(),
    changeCarrierStatus: type<{
      updateSubject: string;
      updateStatus: boolean;
    }>(),
    deleteShipper: type<string>(),
    deleteCarrier: type<string>(),
  },
});
